import ActionType from 'actions/ActionType'

export default (state = { value: [], initialValue: [], error: '' }, action) => {
  switch (action.type) {
    case ActionType.SignupForm.HANDLE_GROUP_CHANGE:
      return { ...state, value: action.payload }
    case ActionType.CustomForm.RECEIVE_FORM:
      if (action.payload) {
        const arr = action.payload.contactgroup_ids
          ? action.payload.contactgroup_ids
              .filter(id => action.groupsByID?.[id])
              .map(id => ({
                groupID: id,
                value: id,
                label: `${
                  action.groupsByID[id] ? action.groupsByID[id].name : 'undefined group'
                }`,
                key: `${id}GroupSelectValue`,
              }))
          : []
        return {
          value: arr,
          initialValue: arr,
        }
      }
      return { value: [], initialValue: [] }
    case ActionType.SignupForm.RECEIVE_FORM:
      if (action.payload) {
        const arr = action.payload.contactgroup_ids
          ? action.payload.contactgroup_ids.map(id => ({
              groupID: id,
              value: id,
              label: `${
                action.groupsByID[id] ? action.groupsByID[id].name : ''
              }`,
              key: `${id}GroupSelectValue`,
            }))
          : []
        return {
          value: arr,
          initialValue: arr,
        }
      }
      return { value: [], initialValue: [] }
    case ActionType.SignupForm.HANDLE_GROUP_SUGGESTION_CLICK:
      return { ...state, value: [...state.value, action.payload] }
    case ActionType.SignupForm.VALIDATION_FAILURE:
      const errorObj = action.errors.find(
        error => error.dataPath === '/contactgroup_ids',
      )
      const error = errorObj ? errorObj.message : ''
      return { ...state, error }
    default:
      return state
  }
}
